import { makeAutoObservable } from "mobx";

class AzureStore {
  disabled = true;
  reset() {
    this.disabled = true;
  }
  constructor() {
    makeAutoObservable(this);
  }

  setDisabled(value) {
    this.disabled = value;
  }
}

export default new AzureStore();
